var render = function render(_c,_vm){return _vm._m(0)
}
var staticRenderFns = [function (_c,_vm){return _c('div',{staticClass:"tiles-header"},[_c('div',[_vm._v("Датасет")]),_c('div',[_vm._v("Метрики / измерения")]),_c('div',[_vm._v("Автор")])])
}]

export { render, staticRenderFns }